import { IAdsData } from '@/api/ads/interfaces';
import LivescoreLayout from '@/components/molecules/LivescoreLayout/LivescoreLayout';
import { ApiMatchEventIdGet200ResponseDataMatch } from '@/api/livescore/generated';
import LivescoreMatchResult from '@/components/molecules/LivescoreMatchResult/LivescoreMatchResult';
import LivescoreMatchHeader from '@/components/molecules/LivescoreMatchHeader/LivescoreMatchHeader';
import LivescoreMatchContent from '@/components/organisms/LivescoreMatchContent/LivescoreMatchContent';
import { LivescoreMatchProvider } from '@/context/LivescoreMatchContext';

interface MatchTemplateProps {
  match: ApiMatchEventIdGet200ResponseDataMatch;
  adsSidebar: IAdsData;
  adsMatch: IAdsData;
}

const MatchTemplate = ({ match, adsSidebar, adsMatch }: MatchTemplateProps) => {
  return (
    <LivescoreLayout ads={adsSidebar}>
      <LivescoreMatchProvider initMatch={match} ads={adsMatch}>
        <main className="border dark:border-border-400 border-gray-250 rounded-lg dark:bg-black-500 bg-white !shrink-0 !grow-0 !h-fit">
          <LivescoreMatchHeader />
          <LivescoreMatchResult />
          <div className="sm:p-4 p-2">
            <h1 className="sr-only">
              {match.sport_event.competitors[0].name} - {match.sport_event.competitors[1].name}
            </h1>
            <LivescoreMatchContent />
          </div>
        </main>
      </LivescoreMatchProvider>
    </LivescoreLayout>
  );
};

export default MatchTemplate;
